PushboxNgController.$inject = ['$scope', '$state', 'loggedUser', 'taskListConfiguration', 'TopToolbarFactory'];
export function PushboxNgController($scope, $state, loggedUser, taskListConfiguration, TopToolbarFactory) {
  $scope.taskListConfiguration = taskListConfiguration;
  $scope.hidePushbox = false;
  $scope.allowed = false;

  init();

  function init() {
    // Can't do this in resolver for state 'auth.alcmeon.pushbox', because it's the parent state, and we don't know at the moment of resolve,
    // in wich state we are (parent or child), because children states trigger parent resolver.
    // With an updated ui-router (> 1.x) we could have this information in $state$, but we don't have it now.
    // So it will go here only for parent state, children are guarded by resolver.
    // Add condition on state name 'auth.alcmeon.pushbox' just in case.
    if (!loggedUser.is_in_push_mode && $state.current.name === 'auth.alcmeon.pushbox') {
      $state.go('auth.alcmeon.after-login');
      return;
    }

    $scope.allowed = true;

    $scope.$watch(
      () => $state.includes('**.pushbox'),
      () => {
        $scope.hidePushbox = !$state.includes('**.pushbox');

        if ($state.includes('**.pushbox')) {
          TopToolbarFactory.clearTitle($scope);
        }
      }
    );

    $scope.$watch(
      () => $state.includes('**.pushbox.tasks'),
      () => {
        if ($state.includes('**.pushbox.tasks')) {
          TopToolbarFactory.setTitle(taskListConfiguration.title, $scope);
        }
      }
    );
  }
}
